export const PLATFORM_UPDATES = [
  {
    id: 'update-20241118-001',
    date: '2024-11-18',
    version: 'v2.3.0',
    type: 'feature',
    title: 'Multi-Platform Review Management',
    description: 'Respond to Google, Yelp, TripAdvisor, and Facebook reviews from one unified dashboard. Includes AI-powered response generation.',
    category: 'Marketing Intelligence',
    impact: 'high',
    icon: '⭐',
    details: [
      'Reply to reviews across all platforms without logging into each site',
      'AI assistant generates contextually appropriate responses',
      'Review collection landing page with QR code support',
      'Real-time review notifications (coming soon)'
    ]
  },
  {
    id: 'update-20241118-002',
    date: '2024-11-18',
    version: 'v2.3.0',
    type: 'feature',
    title: 'State-Specific Compliance Intelligence',
    description: 'Location-based compliance alerts with clickable requirements and action plans for all Australian states.',
    category: 'Regulatory Compliance',
    impact: 'high',
    icon: '⚖️',
    details: [
      'Automatic detection of your business location',
      'State-specific gaming tax rates and brackets',
      'Clickable compliance categories with detailed checklists',
      'Direct links to state regulators',
      'Monthly/daily/annual check frequency indicators'
    ]
  },
  {
    id: 'update-20241118-003',
    date: '2024-11-18',
    version: 'v2.3.0',
    type: 'feature',
    title: 'Data Source Transparency',
    description: 'Click any data source badge to see why it\'s trusted, when it was updated, and link to original source.',
    category: 'Platform',
    impact: 'medium',
    icon: '🔍',
    details: [
      'Clickable badges on all data points',
      'Authority level and trust verification',
      'Last updated dates and update frequency',
      'Direct links to government and industry sources'
    ]
  },
  {
    id: 'update-20241117-001',
    date: '2024-11-17',
    version: 'v2.2.0',
    type: 'enhancement',
    title: 'Interactive Financial Insights',
    description: 'Click on Key Business Insights and Risk Considerations to see detailed action plans with step-by-step guidance.',
    category: 'Projections',
    impact: 'high',
    icon: '💡',
    details: [
      'Comprehensive solutions for each insight/risk area',
      'Actionable step-by-step instructions',
      'Competitive advantage explanations',
      'Export action plans for team distribution'
    ]
  },
  {
    id: 'update-20241117-002',
    date: '2024-11-17',
    version: 'v2.2.0',
    type: 'enhancement',
    title: 'Apple Liquid Glass UI Refresh',
    description: 'Complete UI overhaul with modern liquid glass aesthetic, enhanced animations, and premium feel.',
    category: 'Design',
    impact: 'medium',
    icon: '🎨',
    details: [
      '32-40px backdrop blur for premium frosted glass effect',
      'Interactive hover states with lift animations',
      'Smooth transitions and scale effects',
      'Enhanced depth with multi-layer shadows'
    ]
  },
  {
    id: 'update-20241116-001',
    date: '2024-11-16',
    version: 'v2.1.0',
    type: 'feature',
    title: 'Stripe Payment Integration',
    description: 'Seamless subscription management with Stripe checkout.',
    category: 'Billing',
    impact: 'high',
    icon: '💳',
    details: [
      'One-click subscription upgrades',
      'Secure Stripe checkout flow',
      'Automatic invoice generation',
      'Usage tracking and billing history'
    ]
  },
  {
    id: 'update-20241115-001',
    date: '2024-11-15',
    version: 'v2.0.0',
    type: 'feature',
    title: 'Marketing Intelligence Suite',
    description: 'Complete digital presence analysis with SEO, reviews, social media, and competitor insights.',
    category: 'Marketing Intelligence',
    impact: 'high',
    icon: '📱',
    details: [
      'SEO performance tracking with keyword rankings',
      'Review aggregation from all major platforms',
      'Social media analytics and content insights',
      'Competitor digital benchmarking',
      'AI-powered action plan recommendations'
    ]
  }
];

export const UPDATE_CATEGORIES = {
  feature: { label: 'New Feature', color: 'bg-success/20 text-success border-success/30' },
  enhancement: { label: 'Enhancement', color: 'bg-primary/20 text-primary border-primary/30' },
  fix: { label: 'Bug Fix', color: 'bg-warning/20 text-warning border-warning/30' },
  security: { label: 'Security', color: 'bg-destructive/20 text-destructive border-destructive/30' }
};
